/**
 * @generated SignedSource<<4274ebbb2a202ba57a8d9ba2ba99af49>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserChip_user$data = {
  readonly preferredName: string | null;
  readonly name: string | null;
  readonly avatarUrl: string | null;
  readonly " $fragmentType": "UserChip_user";
};
export type UserChip_user = UserChip_user$data;
export type UserChip_user$key = {
  readonly " $data"?: UserChip_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserChip_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserChip_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "preferredName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatarUrl",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "aeb6315921eca8865be6ecfff961d6cf";

export default node;
